import axios from "../library/axiosConfig";

export default {
  // 优选品牌公寓
  getFeaturedBrands(cityId) {
    return axios.post(`/renth5/rcmd/v1/home/featuredbrands?cityId=${cityId}`, {}, {baseURL: axios.defaults.rcmdMgzf})
  },
  // 优选公寓房源
  getLandlordRooms(cityId) {
    return axios.post(`/renth5/rcmd/v1/home/landlordrooms?cityId=${cityId}`, {}, {baseURL: axios.defaults.rcmdMgzf})
  },
  // 银联首页热门房源
  getHotRooms(cityId) {
    return axios.post(`/rentunpay/rcmd/v1/home/hotRooms?cityId=${cityId}`, {}, {baseURL: axios.defaults.rcmdMgzf})
  },
  //  租房狂欢节 - 品牌馆
  getBrandStore(data) {
    return axios.get(`/renth5/rcmd/v1/activity/brandStore`, Object.assign({baseURL: axios.defaults.rcmdMgzf}, data));
  },
  //  租房狂欢节 - 活动结束
  getActivityStatus(data) {
    return axios.get(`/renth5/rcmd/v1/activity/end`, Object.assign({baseURL: axios.defaults.rcmdMgzf}, data));
  },
  //  租房狂欢节 - 线下活动报名
  underLineRegister(data) {
    return axios.post(`/renth5/rcmd/v1/activity/underLineRegister`, data, {baseURL: axios.defaults.rcmdMgzf});
  },
  //  七夕活动
  getActivityInfo(data) {
    return axios.get(`/renth5/rcmd/v1/activity/qx/activityInfo`, Object.assign({baseURL: axios.defaults.rcmdMgzf}, data));
  },
  // 七夕线下报名
  qxUnderLineRegister(data) {
    return axios.post(`/renth5/rcmd/v1/activity/qx/underLineRegister`, data, {baseURL: axios.defaults.rcmdMgzf, json: true});
  },
  //  支付宝领取红包
  getAliPayBag(data){
    return axios.post(`/renth5/rcmd/v1/activity/qx/underLineRegister`, data, {baseURL: axios.defaults.rcmdMgzf, json: true});
  }
}



// WEBPACK FOOTER //
// ./src/api/rcmd.js